import get from 'lodash.get';

const getBaseLanguageCodes = (rootState) => get(rootState, 'config.common.ws_language_codes.base');

export default getBaseLanguageCodes;
